import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconVideoTour = ({ id, color, width = 23.1, style, ...restProps }: IProps) => {
  const viewBoxWidth = 23.1;
  const viewBoxHeight = 17.2;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 1.9L18 .1c.4-.3.9 0 .9.4v7.6c0 .4-.5.7-.9.4l-2.6-1.8v1.4c0 .3-.3.5-.6.5h-10c-.3 0-.6-.2-.6-.5V.5c.1-.3.4-.5.7-.5h10c.3 0 .6.2.6.5v1.4zm-10 5.7h8.9V1H5.5v6.6zm10-2.2L17.8 7V1.6l-2.4 1.6v2.2zm-5.3 7c-.3-.3-.7-.3-1 0-.3.3-.3.7 0 1l.6.6c-2.2-.2-4.2-.6-5.7-1.3-1.8-.8-2.8-1.8-2.8-2.8.1-.9.7-1.7 1.9-2.4.3-.2.4-.6.2-.9-.1-.4-.6-.5-.9-.3C.4 7.6 0 8.9 0 9.8c0 1.6 1.3 3 3.6 4.1 1.8.8 4 1.3 6.4 1.4l-.7.7c-.3.3-.3.7 0 1 .1.1.3.2.5.2s.3-.1.5-.2l1.8-1.8c.3-.3.3-.7 0-1l-1.9-1.8zm10.9-5.8c-.3-.2-.7-.1-.9.2-.2.3-.1.7.2.9.7.5 1.5 1.2 1.5 2.1 0 .8-.7 1.7-1.9 2.4-1.3.8-3.3 1.4-5.4 1.6-.4 0-.6.4-.6.8 0 .3.3.6.7.6h.1c2.4-.3 4.4-.9 5.9-1.8 1.7-1 2.6-2.2 2.6-3.5-.2-1.3-.9-2.4-2.2-3.3z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconVideoTour;
